// Only for A/B testing purposes
// TODO: remove when iterative testing of component is completed. PXREC-2968
import { __awaiter } from "tslib";
import { getLocale } from "@pb/utils/locale";
import { default as getOptimizelyVanillaSDKInstance } from "@pb/utils/common/getOptimizelyVanillaSDKInstance";
import { default as getOptimizelyFallbackId } from "@pb/utils/common/getOptimizelyFallbackId";
import { decideOptimizelyVanilla } from "@pb/utils/optimizely";
import { EXPERIMENT_KEY1, EXPERIMENT_KEY2, JSON_VARIABLE_KEY } from './optimizelyConstants';
export const optimizelyInstanceHelper = () => __awaiter(void 0, void 0, void 0, function* () {
    const optimizelyClientInstance = getOptimizelyVanillaSDKInstance();
    const result = yield optimizelyClientInstance.onReady();
    const locale = getLocale();
    const userId = getOptimizelyFallbackId();
    const attributes = {
        locale,
    };
    return { result, optimizelyClientInstance, attributes, userId };
});
export function getVariationJSON() {
    return __awaiter(this, void 0, void 0, function* () {
        const { result, optimizelyClientInstance, attributes, userId } = yield optimizelyInstanceHelper();
        const locale = getLocale();
        if (result.success) {
            const isFeatureEnabled = optimizelyClientInstance.isFeatureEnabled(EXPERIMENT_KEY1, userId, attributes);
            if (isFeatureEnabled) {
                const variationJSON = optimizelyClientInstance.getFeatureVariableJSON(EXPERIMENT_KEY1, `${JSON_VARIABLE_KEY}_${locale}`, userId, attributes);
                return variationJSON;
            }
            return null;
        }
        return null;
    });
}
export const optimizelyExperimentPDEMonkiBrandExposedImpact = () => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        decideOptimizelyVanilla(EXPERIMENT_KEY2)
            .then((isOptimizelyEnabled) => {
            resolve(isOptimizelyEnabled);
        })
            .catch((err) => {
            console.error(err);
            resolve(false);
        });
    });
});
const matchStringInObject = (array, searchString, clear = false) => {
    var _a;
    for (const obj of array) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty('text') && ((_a = obj.text) === null || _a === void 0 ? void 0 : _a.includes(searchString))) {
            if (clear)
                obj.text = '';
            return true;
        }
    }
    return false;
};
export const matchInArray = (finalProducts, stringToMatchAndHideInABTest, clear = false) => {
    let found = false;
    finalProducts.forEach((product) => {
        if (product.markers && product.markers.length !== 0) {
            if (matchStringInObject(product.markers, stringToMatchAndHideInABTest, clear)) {
                found = true;
            }
        }
    });
    return found;
};
//# sourceMappingURL=optimizely.js.map